import PageContentContainer from '../../components/PageContentContainer';

import BalanceCard from './components/BalanceCard';
import DebitInfoCard from './components/DebitInfoCard';
import PaymentsCard from './components/PaymentsCard';
import ResponsiveGridLayoutPaymentBanking from './components/ResponsiveGridLayoutPaymentBanking';

import useLocale from '../../app/hooks/useLocale';

import {
  useApplicationFileQuery,
  useBalanceQuery,
  useDebitInformationQuery,
  usePastPaymentsCountQuery,
  useUpcomingPaymentsCountQuery,
} from './queries';

const PaymentsBanking = () => {
  const { t } = useLocale();

  const { data: applicationFile } = useApplicationFileQuery() || {};
  const { data: balance } = useBalanceQuery() || {};
  const { data: debitInformation } = useDebitInformationQuery(applicationFile?.id) || {};
  const { data: upcomingPaymentsCount } = useUpcomingPaymentsCountQuery(applicationFile?.id) || {};
  const { data: pastPaymentsCount } = usePastPaymentsCountQuery(applicationFile?.id) || {};

  const hasStartingBalance = Boolean(balance?.startingBalance);
  const hasPaymentSchedule = (upcomingPaymentsCount ?? 0) > 0 || (pastPaymentsCount ?? 0) > 0;
  const hasPadInfo = Boolean(
    debitInformation?.bankAccountNumber ||
      debitInformation?.bankTransitNumber ||
      debitInformation?.bankBranchNumber ||
      debitInformation?.accountOwner
  );
  const shouldShowPaymentDetails = hasStartingBalance || hasPaymentSchedule || hasPadInfo;

  return (
    <PageContentContainer headerProps={{ title: t.PAYMENTS_AND_BANKING }}>
      <ResponsiveGridLayoutPaymentBanking
        items={
          shouldShowPaymentDetails
            ? [
                <BalanceCard key="balance-card" />,
                <PaymentsCard key="payments-card" />,
                <DebitInfoCard key="debit-info-card" />,
              ]
            : [<BalanceCard key="balance-card" />]
        }
      />
    </PageContentContainer>
  );
};

export default PaymentsBanking;
